module.exports = "../../app/cells/pages/question/related_questions_cell.rb";